/**
 * Общая разметка блоков банд (docs/design-system.md, раздел 4).
 * Рецепты вынесены сюда, чтобы карточки каталога, карточка банды, настройки,
 * казна и аудит не расходились по глубине и радиусам.
 */

/** Карточка стандартной глубины: top-light блик + многослойная тень */
export const CARD_CLASS = 'rounded-2xl border border-white/10 bg-surface shadow-[inset_0_1px_0_rgba(255,255,255,0.07),0_10px_15px_-3px_rgba(0,0,0,0.25),0_4px_6px_-4px_rgba(0,0,0,0.25)]'

/** Мелкая плитка внутри карточки: достаточно блика по кромке */
export const TILE_CLASS = 'rounded-xl border border-white/5 p-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.05)]'

/** Stagger-появление секций страницы (motion/react) */
export const SECTIONS_VARIANT = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } }
}

export const SECTION_VARIANT = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
}
